import { render, staticRenderFns } from "./PrfAnalysisGuide.vue?vue&type=template&id=39f33e2c"
import script from "./PrfAnalysisGuide.vue?vue&type=script&lang=js"
export * from "./PrfAnalysisGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports